// if (!customElements.get('product-form')) {
//   customElements.define('product-form', class ProductForm extends HTMLElement {
//     constructor() {
//       super();
//       this.form = this.querySelector('form');         
//       if(!this.form) return;
//       this.form.querySelector('[name=id]').disabled = false;
//       this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//       this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//       this.submitButton = this.querySelector('[type="submit"]');
//       if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
//       this.hideErrors = this.dataset.hideErrors === 'true';
//       const selectElement = this.form.querySelector('[name=id]');          
//       const listItems = this.form.querySelectorAll("#variantList li");
//       if(!listItems) return;      
//       const optionDiv = this.form.querySelector('#variantList');
//         listItems.forEach(item => {
//           item.addEventListener("click", function(event) {      
//             const value = this.getAttribute("data-value");          
//             const variantPrice = this.getAttribute('data-price');            
//             const variantQTY = this.getAttribute('data-inventory');           
//             selectElement.value = value;               
//             const closestList = event.target.parentElement.closest('.variantPick');                       
//             const priceContainer = closestList.querySelector(".price-item--sale");   
//             priceContainer.innerHTML = variantPrice;                     
//             var variantMedia = this.getAttribute("data-variant-media");            
//              this.closest('.card-wrapper').querySelector('.card__inner .featured-media').setAttribute("srcset", variantMedia);
//           });
          
//       }); 
//     }

//     onSubmitHandler(evt) {
//       evt.preventDefault();
//       if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

//       this.handleErrorMessage();

//       this.submitButton.setAttribute('aria-disabled', true);
//       this.submitButton.classList.add('loading');
//       this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

//       const config = fetchConfig('javascript');
//       config.headers['X-Requested-With'] = 'XMLHttpRequest';
//       delete config.headers['Content-Type'];

//       const formData = new FormData(this.form);   
      
//        if (this.cart) {
//           formData.append(
//             'sections',
//             this.cart.getSectionsToRender().map((section) => section.id)
//           );
//           formData.append('sections_url', window.location.pathname);
//           this.cart.setActiveElement(document.activeElement);
//         }

      
//       config.body = formData;
    

//       fetch(`${routes.cart_add_url}`, config)
//         .then((response) => response.json())
//         .then((response) => {
//           if (response.status) {
//             this.handleErrorMessage(response.description);

//             const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
//             if (!soldOutMessage) return;
//             this.submitButton.setAttribute('aria-disabled', true);
//             this.submitButton.querySelector('span').classList.add('hidden');
//             soldOutMessage.classList.remove('hidden');
//             this.error = true;
//             return;
//           } else if (!this.cart) {
//               window.location = window.routes.cart_url;
//               return;
//             }

//           this.error = false;
//           const quickAddModal = this.closest('quick-add-modal');
//           if (quickAddModal) {
//             document.body.addEventListener('modalClosed', () => {
//               setTimeout(() => { this.cart.renderContents(response) });
//             }, { once: true });
//             quickAddModal.hide(true);
//           } else {
//             this.cart.renderContents(response);
//           }
//             console.log(Object.fromEntries(formData.entries()));
//         })
//         .catch((e) => {
//           console.error(e);
//         })
//         .finally(() => {
//           this.submitButton.classList.remove('loading');
//           if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
//           if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//           this.querySelector('.loading-overlay__spinner').classList.add('hidden');
//            setTimeout(function(){
//          	giftCart();
//           }, 1000); 
//         });
//     }

//     handleErrorMessage(errorMessage = false) {
//        if (this.hideErrors) return;
//       this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
//       if (!this.errorMessageWrapper) return;
//       this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
//       this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
//       if (errorMessage) {
//         this.errorMessage.textContent = errorMessage;
//       }
//     }
//   });
// }

// $(document).ajaxComplete(function() {
// //  CartJS.updateCart();
// });


// function giftCart() {
//   const cartItems = document.querySelectorAll('tr.cart-item');
//     cartItems.forEach(cartItem => {        
//         const dataId = cartItem.getAttribute('data-id');
//         const drawerFooter = document.querySelector(`#Gift-Wrapper[data-id="${dataId}"]`);  
//       if(!drawerFooter) return;
//       const drawerFooterID = drawerFooter.getAttribute('data-id');
//         if(drawerFooterID == dataId) {            
//             drawerFooter.classList.add('Gift-Wrapper__hide'); 
//         }
//     });
// }

// if (!customElements.get('product-form')) {
//   customElements.define('product-form', class ProductForm extends HTMLElement {
//     constructor() {
//       super();
//       this.form = this.querySelector('form');         
//       if(!this.form) return;
//       this.form.querySelector('[name=id]').disabled = false;
//       this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//       this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//       this.submitButton = this.querySelector('[type="submit"]');
//       if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
//       this.hideErrors = this.dataset.hideErrors === 'true';
//       const selectElement = this.form.querySelector('[name=id]');          
//       const listItems = this.form.querySelectorAll("#variantList li");
//       const chooseBtn = this.form.querySelector('.choose-variant');
//       if(!chooseBtn) return;            
//       const optionDiv = this.form.querySelector('#variantList');
//        chooseBtn.addEventListener('click', function() {
//         optionDiv.classList.toggle('active');
//         });
//       if(!listItems) return;
//         listItems.forEach(item => {
//           item.addEventListener("click", function(event) {   
//               const value = this.getAttribute("data-value");  
//             const variantPrice = this.getAttribute('data-price');   
//              selectElement.value = value;       
//             const closestList = event.target.parentElement.closest('.variantPick');                       
//             const priceContainer = closestList.querySelector(".price-item--sale");   
//             priceContainer.innerHTML = variantPrice;                     
//             var variantMedia = this.getAttribute("data-variant-media");            
//             this.closest('.card-wrapper').querySelector('.card__inner .featured-media').setAttribute("srcset", variantMedia);
//             optionDiv.classList.remove('active');
//           });
          
//       }); 
//     }

//     onSubmitHandler(evt) {
//       evt.preventDefault();
//       if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

//       this.handleErrorMessage();

//       this.submitButton.setAttribute('aria-disabled', true);
//       this.submitButton.classList.add('loading');
//       this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

//       const config = fetchConfig('javascript');
//       config.headers['X-Requested-With'] = 'XMLHttpRequest';
//       delete config.headers['Content-Type'];

//       const formData = new FormData(this.form);   
      
//        if (this.cart) {
//           formData.append(
//             'sections',
//             this.cart.getSectionsToRender().map((section) => section.id)
//           );
//           formData.append('sections_url', window.location.pathname);
//           this.cart.setActiveElement(document.activeElement);
//         }

      
//       config.body = formData;
    

//       fetch(`${routes.cart_add_url}`, config)
//         .then((response) => response.json())
//         .then((response) => {
//           if (response.status) {
//             this.handleErrorMessage(response.description);

//             const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
//             if (!soldOutMessage) return;
//             this.submitButton.setAttribute('aria-disabled', true);
//             this.submitButton.querySelector('span').classList.add('hidden');
//             soldOutMessage.classList.remove('hidden');
//             this.error = true;
//             return;
//           } else if (!this.cart) {
//               window.location = window.routes.cart_url;
//               return;
//             }

//           this.error = false;
//           const quickAddModal = this.closest('quick-add-modal');
//           if (quickAddModal) {
//             document.body.addEventListener('modalClosed', () => {
//               setTimeout(() => { this.cart.renderContents(response) });
//             }, { once: true });
//             quickAddModal.hide(true);
//           } else {
//             this.cart.renderContents(response);
//           }
//             console.log(Object.fromEntries(formData.entries()));
//         })
//         .catch((e) => {
//           console.error(e);
//         })
//         .finally(() => {
//           this.submitButton.classList.remove('loading');
//           if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
//           if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//           this.querySelector('.loading-overlay__spinner').classList.add('hidden');
//            setTimeout(function(){
//          	giftCart();
//           }, 1000); 
//         });
//     }

//     handleErrorMessage(errorMessage = false) {
//        if (this.hideErrors) return;
//       this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
//       if (!this.errorMessageWrapper) return;
//       this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
//       this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
//       if (errorMessage) {
//         this.errorMessage.textContent = errorMessage;
//       }
//     }
//   });
// }

// $(document).ajaxComplete(function() {
// //  CartJS.updateCart();
// });


// function giftCart() {
//   const cartItems = document.querySelectorAll('tr.cart-item');
//     cartItems.forEach(cartItem => {        
//         const dataId = cartItem.getAttribute('data-id');
//         const drawerFooter = document.querySelector(`#Gift-Wrapper[data-id="${dataId}"]`);  
//       if(!drawerFooter) return;
//       const drawerFooterID = drawerFooter.getAttribute('data-id');
//         if(drawerFooterID == dataId) {            
//             drawerFooter.classList.add('Gift-Wrapper__hide'); 
//         }
//     });
// }
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';

      const selectElement = this.form.querySelector('[name=id]');
      const listItems = this.form.querySelectorAll("#variantList li");
      const chooseBtn = this.form.querySelector('.choose-variant');
      const optionDiv = this.form.querySelector('#variantList');

      if (!chooseBtn || !optionDiv || !listItems.length) return;

      // Toggle dropdown
      chooseBtn.addEventListener('click', function () {
        optionDiv.classList.toggle('active');
      });

      // Handle variant selection
      listItems.forEach(item => {
        item.addEventListener("click", function (event) {
          const value = this.getAttribute("data-value");
          const variantPrice = this.getAttribute("data-price");
          const variantMedia = this.getAttribute("data-variant-media");

          // Set selected value
          selectElement.value = value;

          // Update price
          const closestList = event.target.closest('.variantPick');
          const priceContainer = closestList?.querySelector(".price-item--sale");
          if (priceContainer) {
            priceContainer.innerHTML = variantPrice;
          }

          // Update product image
          const productImage = this.closest('.card-wrapper')?.querySelector('.card__inner .featured-media');
          if (productImage) {
            productImage.setAttribute("srcset", variantMedia);
          }

          // ✅ Remove dropdown open class
          optionDiv.classList.remove('active');

          // ✅ Highlight selected option
          listItems.forEach(li => li.classList.remove('active'));
          this.classList.add('active');
        });
      });
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => {
                this.cart.renderContents(response);
              });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }

          console.log(Object.fromEntries(formData.entries()));
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          setTimeout(() => {
            giftCart();
          }, 1000);
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

$(document).ajaxComplete(function () {
  // CartJS.updateCart();
});

function giftCart() {
  const cartItems = document.querySelectorAll('tr.cart-item');
  cartItems.forEach(cartItem => {
    const dataId = cartItem.getAttribute('data-id');
    const drawerFooter = document.querySelector(`#Gift-Wrapper[data-id="${dataId}"]`);
    if (!drawerFooter) return;
    const drawerFooterID = drawerFooter.getAttribute('data-id');
    if (drawerFooterID === dataId) {
      drawerFooter.classList.add('Gift-Wrapper__hide');
    }
  });
}






